import Vue from 'vue'
import Vuex from 'vuex'
import api from './libs/api'

Vue.use(Vuex)

let store=new Vuex.Store({
    state: {
		activeCity:'',
		cityList:[],
        activeAddr: null,
        addrData: [],
        rent_sale_price_danwei: {
            1: "元/㎡/天",
            2: "元/㎡/月",
            3: "元/㎡"
        }
    },
    getters: {
        activeAddr: function(state){
            return state.activeAddr
        },
        rent_sale_price_danwei: function(state){
            return state.rent_sale_price_danwei
        }
    },
    mutations: {
		setActiveAddr(state, addr){
			console.log(addr)
		    state.activeCity = addr;
		},
        changeActiveAddr(state, addr){
            state.activeAddr = addr;
        },
		setalladdress(state, cityList){
			
			
			state.cityList=cityList
			
			
		}
    },
    actions: {
		getaddress(context){
			
			
			api.getCityInfo().then(function(response){
			    let cityList = response;
			    if(!context.state.activeAddr){
			    	context.commit('setActiveAddr',cityList[0].name)
			    	context.commit('changeActiveAddr',cityList[0])
			    }
				context.commit('setalladdress',cityList)
			    
			})
			
		}
	}
})

export default store
